<section class="p-5">
  <div class="flex flex-row items-center relative">
    <p-button icon="true"
              class="absolute top-[-0.5rem] right-[-0.5rem]"
              severity="contrast"
              rounded="true"
              styleClass="!size-[1.75rem] !px-0 !py-0"
              [text]="true"
              (click)="close()">
      <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
    </p-button>
  </div>

  <div class="flex flex-col gap-[0.75rem]">
    <div class="flex flex-col gap-[1rem]">
      <header class="flex flex-row items-center text-(--p-red-500) text-[1rem] font-semibold gap-[0.75rem]">
        <span class="flex flex-row items-center justify-center border-[1px] border-solid rounded-full border-[currentColor] p-[0.625rem]">
          <svg-icon class="size-[1.25rem]" src="icons/icon-helper.svg" name="icon-helper"></svg-icon>
        </span>
        @if (data?.statusDescription) {
          <span [translate]="data?.statusDescription || ''"></span>
        } @else if (data?.status) {
          <span>{{data?.status}}</span>
        } @else {
          <span translate="@@dialog-error-intercepted__default-status-description"></span>
        }
      </header>

      <gc-info-message [showIcon]="false" [type]="InfoMessageStatus.Error">
        <div class="flex flex-col gap-[0.75rem]">
          @if (data?.status === BaseErrorStatus.MalformedInputData) {
            <div [translate]="malformedInputDataMessage" [translateParams]="malformedInputDataParams"></div>
          } @else {
            <div>{{data?.message}}</div>
          }
        </div>
      </gc-info-message>

    </div>

    <div class="flex flex-row items-center justify-end">
      <p-button
              severity="secondary"
              [outlined]="true"
              styleClass="!text-[0.875rem] !px-[1rem] !py-[0.4375rem] uppercase"
              (click)="close()"
      >
        {{ closeButtonLabel | translate }}
      </p-button>
    </div>
  </div>
</section>

